export class DeclaracionPj {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                header: 'Código'
            },
            pep: {
                value: null,
                export: false,
                header: 'Declaro que me encuentro ejerciendo y/o he ejercido hace un (1) año cargos públicos:',
                required: 'Debe declarar si es PEP o no'
            },
            cargo_pep: {
                value: '',
                export: false,
                header: 'Cargo:',
                max: 100,
                required: 'El cargo es requerido'
            },
            tiempo_pep: {
                value: '',
                export: false,
                header: 'Tiempo en el cargo:',
                max: 100,
                required: 'El tiempo en el cargo es requerido'
            },
            relacion_pep: {
                value: null,
                export: false,
                header: 'Declaro que tengo y/o he tenido hace un (1) año relación con personas expuestas políticamente (pep) hasta el cuarto grado de consanguinidad y segundo de afinidad:',
                required: 'Debe declarar si tiene relación con un PEP'
            },
            nombre_pep: {
                value: '',
                export: false,
                header: 'Nombre de la persona PEP:',
                max: 100,
                required: 'El nombre es requerido'
            },
            cargo_nombre_pep: {
                value: '',
                export: false,
                header: 'Cargo PEP:',
                max: 100,
                required: 'El cargo es requerido'
            },
            tiempo_nombre_pep: {
                value: '',
                export: false,
                header: 'Tiempo en el cargo:',
                max: 100,
                required: 'El tiempo en el cargo es requerido'
            },
            tipo_relacion_pep: {
                value: '',
                export: false,
                header: 'Tipo de relación con la PEP:',
                max: 100,
                required: 'El tipo de relación es requerido'
            },
        }
    }

    strAutorizacionTratamientoDatos = <>
        <ol style={{ paddingLeft: "13px", }}>
            <li>El Responsable de los Datos Personales ha puesto en mi conocimiento su Política de Tratamiento de Datos Personales, la misma que me ha sido entregada y que consta en su página web. En ella constan los principios, cuidados y derechos respecto al tratamiento de mis datos personales.</li>
            <br />
            <li>De conformidad con el art. 8 de la Ley Orgánica de Protección de Datos Personales y art. 5 de su Reglamento, con la suscripción del presente formulario, consiento de manera libre, previa, expresa, voluntaria, y debidamente informada al Responsable de los Datos Personales, para que realice el tratamiento de mis datos personales en calidad de responsable. Entiendo que mis datos personales podrán ser compartidos con terceros, en concordancia con las disposiciones legales.</li>
            <br />
            <li>El Responsable de los Datos Personales declara que el tratamiento de datos personales se realizará dentro de los límites y de conformidad y con fundamento en lo dispuesto en el Art. 66 nº 19 de la Constitución de la República, la Ley Orgánica de Prevención, Detección y Combate del Delito de Lavado de Activos y de la Financiación de Otros Delitos y la LOPDP. El Responsable tratará mis datos personales con reserva y ha adoptado las medidas técnicas y organizativas necesarias para garantizar su seguridad, integridad y confidencialidad.</li>
            <br />
            <li>Los datos y documentación que aporto mediante el presente formulario son veraces y exactos, y el Responsable podrá efectuar las validaciones que considere pertinentes.</li>
            <br />
            <li>Autorizo al Responsable de los Datos Personales a contactarme y enviarme comunicaciones por cualquier medio, teniendo en consideración la finalidad antes expresada. Asimismo, podré comunicarme con el Responsable en cualquier momento si tengo preguntas o solicitudes sobre el tratamiento de mis datos personales.</li>
        </ol>
    </>;

    msgAcceso = <><p style={{ textAlign: 'justify' }}>Autorizo de manera expresa a Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A. a verificar por los medios que
        estime pertinentes los datos aquí proporcionados. Así mismo autorizo para que a través de los datos constantes en el Registro Crediticio, Burós de información y otras
        fuentes, puedan acceder a la obtención de información del suscrito, de mi representada, sobre mi (nuestro) comportamiento crediticio, manejo de mi (s) (nuestras) cuenta
        (s) corriente (s), de ahorro, tarjeta (s) de crédito, etcétera, y en general sobre el cumplimiento de mis (nuestras) obligaciones y demás activos, pasivos y datos personales.</p></>;

    msgDeclaracion = <><p>Certifico que la información proporcionada en este formulario es correcta y completa. Autorizo a TRUST FIDUCIARIA ADMINISTRADORA DE FONDOS Y FIDEICOMISOS S.A.
        a proporcionar, directa o indirectamente, la información contenida es este formulario y/o una copia del mismo a cualquier autoridad fiscal pertinente o a cualquier
        parte autorizada para auditar o realizar un control similar de TRUST FIDUCIARIA para fines fiscales; así como, a divulgar a tales autoridades fiscales o parte autorizada
        cualquier información adicional que pudiese poseer TRUST FIDUCIARIA y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación.
        Acepto que la información contenida en este formulario y la información relacionada con mis cuentas en TRUST FIDUCIARIA (incluso la información sobre los saldos de cuentas y
        pagos recibidos) se notifique a las autoridades fiscales pertinentes y, que estas autoridades, proporcionen esta información a cualquier otro país enumerado en la lista anterior,
        como a un país en el cual soy residente para fines fiscales. Me comprometo a avisar inmediatamente a TRUST FIDUCIARIA sobre cualquier cambio en las circunstancias que motive que
        la información contenida en este documento sea incorrecta y a proporcionar a TRUST FIDUCIARIA un formulario actualizado y apropiado de Auto-certificación de Residencia Fiscal en
        un plazo de 30 días a partir de la fecha de cambio de circunstancias.</p></>

}